import React, { useEffect } from 'react'

import { blurAllCells } from '@react-page/core/lib/actions/cell'
import { connect } from '@react-page/core/lib/reduxConnect'

const MAX_LEVEL = 10

// this might break in future, but its better than nothing
// tslint:disable-next-line:no-any
function findReactElement(node, level = 0) {
    if (level >= MAX_LEVEL) {
        return null
    }

    for (var key in node) {
        // React 17+ stores the fiber under __reactFiber$; React 16 used __reactInternalInstance$
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) {
            return node[key]
        }
    }

    if (node.parentElement) {
        return findReactElement(node.parentElement, level + 1)
    }

    return null
}

function isCKEditorToolbar(node) {
    if (!(node instanceof HTMLElement)) {
        return isCKEditorToolbar(node.parentElement)
    }

    return !!node.className.split(' ').find(item => item === 'ck')
}

const isInSameTree = (parent, child) => {
    if (!parent) {
        return false
    }

    if (parent.contains(child) || isCKEditorToolbar(child)) {
        return true
    }

    // Walk the React tree as well, so content rendered through portals counts as inside
    let element = findReactElement(child)

    while (element) {
        if (element.stateNode === parent) {
            return true
        }

        element = element.return
    }

    return false
}

export const useBlurAll = blurAllCellsDispatch => {
    const ref = React.useRef()

    useEffect(() => {
        if (!ref.current) {
            return null
        }

        if (!document && !document.body) {
            return null
        }

        const onMouseDown = e => {
            if (!isInSameTree(ref.current, e.target)) {
                blurAllCellsDispatch()
            }
        }

        // Capture phase: since React 17 events are handled at the root container, so a bubbling
        // listener on body runs after React has re-rendered and may see a target that has
        // already been removed from the DOM, which would wrongly blur the cell just clicked
        document.body.addEventListener('mousedown', onMouseDown, true)

        return () => {
            document.body.removeEventListener('mousedown', onMouseDown, true)
        }
    }, [ref.current])

    return ref
}

const mapDispatchToProps = { blurAllCells }

const BlurGate = props => {
    const ref = useBlurAll(props.blurAllCells)
    return <div ref={ref}>{props.children}</div>
}

export default connect(null, mapDispatchToProps)(BlurGate)
